module.exports = __webpack_public_path__ + "static/img/t1-5.07f4f0f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/t1-5.jpg
// module id = xBaH
// module chunks = 1